<script>
import { FormWizard, TabContent } from "vue-form-wizard";

export default {
  components: { FormWizard, TabContent },
  props: {
    planoContas: {
      type: Array,
      required: true
    },
    professionals: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      contas: [],
      filteredTipos: [],
      pagamentos: [],
      tipos: [
        {id: 1, codigo: 1, descricao: 'Pagamento', grupo_pgto: 'av' },
        {id: 2, codigo: 2, descricao: 'Recebimento', grupo_pgto: 'av' },
        {id: 3, codigo: 3, descricao: 'A Prazo', grupo_pgto: 'ap' },
        {id: 4, codigo: 4, descricao: 'Cartão', grupo_pgto: 'ap' },
      ],
      fieldsArquivos: [],
      file: null,
      errors: {},
      loader: { get: false },
      titleBody: "Incluir Conta a Pagar",
      selectedGrupoPgto: null,
      accountsPayable: {
        vencimento: null,
        numeroDocumento: null,
        valorPagar: null,
        descricao: null,
        conta_credito_id: null,
        conta_debito_id: null,
        tipo_id: null,
        arquivos: [],
        data_pagamento: null,
        status: 0,
        professional_id: null,
      },
    };
  },
  created() {
    this.contas       = this.planoContas.filter(conta => conta.conta_pgto === 1)
    this.pagamentos   = this.planoContas.filter(conta => conta.conta_pgto === 0 && conta.grupo_pgto !== null)
    this.currentUser  = JSON.parse(localStorage.getItem('user'))
    this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'))
  },
  mounted() {
    this.$emit("newTitle", "Cadastrar Conta a Pagar")
    this.setTipo(this.tipos[0])
  },
  computed: {
  },
  watch: {
    // Verifica quando o conta_debito_id é alterado
    'accountsPayable.conta_debito_id': function(newValue) {
      const selectedPagamento = this.pagamentos.find(conta => conta.id === newValue)

      if (selectedPagamento) {
        this.selectedGrupoPgto = selectedPagamento.grupo_pgto

        if (this.selectedGrupoPgto === 'av') { // Verifica se o grupo de pagamento é 'av'
            // Filtra os tipos apenas para 'Pagamento' e 'Recebimento'
            this.filteredTipos = this.tipos.filter(tipo => tipo.descricao === 'Pagamento' || tipo.descricao === 'Recebimento')
        } else {
            // Caso contrário, mostra 'A Prazo' e 'Cartão'
            this.filteredTipos = this.tipos.filter(tipo => tipo.descricao === 'A Prazo' || tipo.descricao === 'Cartão')
        }
      }
    },
  },
  methods: {
    back() {
      this.$emit('back');
    },
    setNewTitle() {
      this.titleBody = 'Incluir Conta a Pagar'
    },
    filterContaContabil(descricao) {
      let contasDespesas = this.planoContas.filter(conta => conta.conta_pgto === 1)

      if (!descricao) {
        this.contas = contasDespesas
      } else {
        this.contas = contasDespesas.filter(conta => conta.descricao.toLowerCase().includes(descricao.toLowerCase()))
      }
    },
    filterContaPagamento(descricao) {
      let contasPagamentos = this.planoContas.filter(conta => conta.conta_pgto === 0)

      if (!descricao) {
        this.pagamentos = contasPagamentos
      } else {
        this.pagamentos = contasPagamentos.filter(conta => conta.descricao.toLowerCase().includes(descricao.toLowerCase()))
      }
    },
    setConta(conta_credito) {
      if (conta_credito === this.accountsPayable.conta_credito) {
        this.accountsPayable.conta_credito_id = null
        this.accountsPayable.conta_credito = null
        return
      }

      this.accountsPayable.conta_credito_id = conta_credito.id
      this.accountsPayable.conta_credito = conta_credito
      this.$refs.wizardContasPagar.nextTab()
    },
    setPagamento(conta_debito) {
      if (conta_debito === this.accountsPayable.conta_debito) {
        this.accountsPayable.conta_debito_id = null
        this.accountsPayable.conta_debito = null
        return
      }

      this.accountsPayable.conta_debito_id = conta_debito.id
      this.accountsPayable.conta_debito = conta_debito
      this.$refs.wizardContasPagar.nextTab()
    },
    setTipo(tipo) {
      this.accountsPayable.tipo_id = tipo.id
      this.accountsPayable.tipo = tipo
    },
    doPost() {
      let data = {
        ...this.accountsPayable,
        conta_debito_id: this.accountsPayable.conta_debito_id,
        conta_credito_id: this.accountsPayable.conta_credito_id,
        descricao: this.accountsPayable.descricao,
        numero_documento: this.accountsPayable.numeroDocumento,
        valor_pagar: this.accountsPayable.valorPagar.replace('.', '').replace(',', '.').trim(),
        vencimento: this.accountsPayable.vencimento,
        data_emissao: this.accountsPayable.vencimento,
        ano_competencia: parseInt(this.accountsPayable.competencia.split('-')[0]),
        mes_competencia: parseInt(this.accountsPayable.competencia.split('-')[1]),
        data_pagamento: this.accountsPayable.data_pagamento,
        status: this.accountsPayable.status,
        quantidade_parcelas: 1,
      }
      this.$emit('doPost', data)
    },
    deleteFile() {},
    onFileChange() {},
    // Validação global antes de mudar de aba
    beforeTabChange(oldIndex) {
      return this.validateCurrentStep(oldIndex)
    },
    // Validação específica do step 1
    validateStep1() {
      this.errors = {}

      if (!this.accountsPayable.vencimento) {
        this.errors.vencimento = 'Data de emissão é obrigatória'
        this.$refs.vencimento.focus()
      }

      if (!this.accountsPayable.numeroDocumento) {
        this.errors.numeroDocumento = 'Documento é obrigatório'
        this.$refs.numeroDocumento.focus()
      }

      if (!this.accountsPayable.valorPagar) {
        this.errors.valorPagar = 'Valor é obrigatório'
        this.$refs.valorPagar.focus()
      }

      return Object.keys(this.errors).length === 0
    },
    validateStep2() {
      this.errors = {}

      if (!this.accountsPayable.conta_credito_id) {
        this.errors.conta_credito_id = 'Conta Contábil é obrigatória'
        this.$refs.conta_credito_id.focus()
      }

      return Object.keys(this.errors).length === 0
    },
    validateStep3() {
      this.errors = {}

      if (!this.accountsPayable.conta_debito_id) {
        this.errors.conta_debito_id = 'Conta Pagamento é obrigatória'
        this.$refs.conta_debito_id.focus()
      }

      return Object.keys(this.errors).length === 0
    },
    validateStep4() {
      this.errors = {}
      // Data de pagamento não é obrigatório
      // Se a data de pagamento for preenchida, pagamento.status deve ser 1
      if (this.accountsPayable.data_pagamento) {
        this.accountsPayable.status = 1
      }

      return Object.keys(this.errors).length === 0
    },
    validateCurrentStep(stepIndex) {
      switch (stepIndex) {
        case 0:
          return this.validateStep1()
        case 1:
          return this.validateStep2()
        case 2:
          return this.validateStep3()
        case 3:
          return this.validateStep4()
      }
    }
  },
};
</script>
<template>
    <form-wizard color="#556ee6"
      ref="wizardContasPagar"
      next-button-text="Avançar"
      finish-button-text="Gravar"
      back-button-text="Voltar"
      @on-complete="doPost"
      :before-change="beforeTabChange"
    >
      <tab-content icon="mdi mdi-file-percent"
        :before-change="validateStep1"
      >
        <div class="row">
          <div class="col-md-2">
            <label for="vencimento">Vencimento</label>
            <input type="date" class="form-control" id="vencimento" v-model="accountsPayable.vencimento" ref="vencimento">
            <span v-if="errors.vencimento" class="error">{{ errors.vencimento }}</span>
          </div>
          <div class="col-md-2">
            <label for="competencia">Competência</label>
            <b-form-input type="month" class="form-control" id="competencia" v-model="accountsPayable.competencia" ref="competencia">
              <template #prepend>
                <b-form-input-group>
                  <b-form-input-group-prepend is-text>
                    <b-icon icon="calendar" />
                  </b-form-input-group-prepend>
                </b-form-input-group>
              </template>
            </b-form-input>
            <span v-if="errors.competencia" class="error">{{ errors.competencia }}</span>
          </div>
          <div class="col-md-6">
            <label for="numeroDocumento">Documento</label>
            <input type="text" class="form-control" id="numeroDocumento" v-model="accountsPayable.numeroDocumento" ref="numeroDocumento">
            <span v-if="errors.numeroDocumento" class="error">{{ errors.numeroDocumento }}</span>
          </div>
          <div class="col-md-2">
            <label for="valorPagar">Valor R$</label>
            <input type="text" class="form-control text-right" id="valorPagar" ref="valorPagar"
              v-model="accountsPayable.valorPagar"
              @input="formatInputFloat($event,accountsPayable,'valorPagar')"
            >
            <span v-if="errors.valorPagar" class="error">{{ errors.valorPagar }}</span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <label for="descricao">Histórico (descrição)</label>
            <input type="text" class="form-control" id="descricao" v-model="accountsPayable.descricao">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6">
            <label for="professional_id">Profissional <small class="text-muted">(opcional)</small></label>
            <select id="professional_id" class="form-control" v-model="accountsPayable.professional_id">
              <option :value="null">Sem profissional</option>
              <option v-for="professional in professionals" :key="professional.id" :value="professional.id">
                {{ professional.name }}
              </option>
            </select>
          </div>
        </div>
      </tab-content>
      <tab-content icon="mdi mdi-file-tree"
        :before-change="validateStep2"
      >
        <h2>Selecionar Categoria</h2>
        <b-row cols="1">
          <div class="position-relative">
            <form class="app-search d-none d-lg-block" @submit.prevent>
              <div class="position-relative">
                <input
                  name="contaContabil"
                  type="text"
                  class="form-control"
                  placeholder="Buscar por Conta Contábil"
                  @input="filterContaContabil($event.target.value)"
                  ref="conta_credito_id"
                />
                <span class="ri-search-line"></span>
              </div>
            </form>
          </div>
          <span v-if="errors.conta_credito_id" class="error">{{ errors.conta_credito_id }}</span>
        </b-row>
        <div class="row">
          <div class="col-12 max-h-96 overflow-y-auto">
            <!-- loop array contas -->
            <b-row cols="1" v-for="conta in contas" :key="conta.id" class="cursor-pointer">
              <b-col @click="setConta(conta)">
                <b-card class="flex" :class="(accountsPayable.conta_credito_id === conta.id) ? 'bg-light' : 'bg-default'">
                  <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                    <span class="text-lg font-semibold">{{ conta.descricao.substring(0, 1) }}</span>
                  </b-badge>
                  <span class="flex items-center ml-3">
                    {{  conta.descricao }}
                  </span>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </tab-content>
      <tab-content icon="mdi mdi-bank-transfer"
        :before-change="validateStep3"
      >
        <h2>Selecionar Pagamento</h2>
        <b-row cols="1">
          <div class="position-relative">
            <form class="app-search d-none d-lg-block" @submit.prevent>
              <div class="position-relative">
                <input
                  name="contaContabil"
                  type="text"
                  class="form-control"
                  placeholder="Buscar por Conta Pagamento"
                  @input="filterPagamentos($event.target.value)"
                  ref="conta_debito_id"
                />
                <span class="ri-search-line"></span>
              </div>
            </form>
          </div>
          <span v-if="errors.conta_debito_id" class="error">{{ errors.conta_debito_id }}</span>
        </b-row>
        <div class="row">
          <div class="col-12 max-h-96 overflow-y-auto">
            <b-row cols="1" v-for="pagamento in pagamentos" :key="pagamento.id" class="cursor-pointer">
              <b-col @click="setPagamento(pagamento)">
                <b-card class="flex" :class="(accountsPayable.conta_debito_id === pagamento.id) ? 'bg-light' : 'bg-default'">
                  <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                    <span class="text-lg font-semibold">{{ pagamento.descricao.substring(0, 1) }}</span>
                  </b-badge>
                  <span class="flex items-center ml-3">
                    {{  pagamento.descricao }}
                  </span>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </tab-content>
      <tab-content icon="mdi mdi-calendar"
        :before-change="validateStep4"
      >
        <h2>Data de Pagamento</h2>
        <b-row cols="1">
          <div class="col-md-3 col-sm-12">
            <label for="data_pagamento">Data de Pagamento</label>
            <input type="date" class="form-control" id="data_pagamento" v-model="accountsPayable.data_pagamento" ref="data_pagamento">
            <span v-if="errors.data_pagamento" class="error">{{ errors.data_pagamento }}</span>
          </div>
        </b-row>
      </tab-content>
    </form-wizard>
</template>

<style>
.w-12 {
  width: 3rem;
}
.h-12 {
  height: 3rem;
}
.text-lg {
  font-size: 1.900rem;
  line-height: 1.75rem;
}
.rounded-full {
  border-radius: 9999px;
}
.justify-center {
  justify-content: center;
}
.font-semibold {
  font-weight: 600;
}
.items-center {
  align-items: center;
}
.pt-8 {
  padding-top: 0.5rem;
}
.max-h-96 {
  max-height: 24rem;
}
.overflow-y-auto {
  overflow-y: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.capitalize {
  text-transform: capitalize;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

/* CSS para destacar abas com erro */
.vue-form-wizard .wizard-nav-pills > li.has-error > a {
  color: #dc3545 !important;
  border-color: #dc3545 !important;
}

.vue-form-wizard .wizard-nav-pills > li.has-error > a:after {
  background-color: #dc3545 !important;
}
</style>
